const {CardDeck, MilitaryCardTypes}  = require("../../Constants/Constants");
const Card = require("./Card");

class AggressionCard extends Card{
    constructor(aggression)
    {
        super(
            CardDeck.Military,
            MilitaryCardTypes.Aggression,
            null,
            aggression.GetName(),
            aggression.GetAge(),
            aggression.GetText(),
            aggression.GetEffects(),
        )
        this.aggression = aggression;
    }
}

module.exports = AggressionCard;